import { connect } from "react-redux";
import View from "./View";
import { RootState } from "src/ipm-shared/store/model/reducers";
import { FORM } from "src/ipm-shared/store/model/Payee/const";

import * as actions from "../actions";
import * as selectors from "../selectors";

const mapStateToProps = (state: RootState) => ({
  filesControl: selectors.getFileControl(
    state,
    selectors.getControlsPattern(state, /^document_tag_/),
    "document_tag_"
  ),
  formState: selectors.getControls(state, FORM),
  supplierPayoutType: selectors.supplierPayoutType(state),
  isSingaporeAccount: selectors.isSingaporeAccount(state),
  isSupplierPayoutUEN: selectors.isSupplierPayoutUEN(state),
  getControl: (name: string, form: string) =>
    selectors.getControl(state, name, form)
});

const mapDispatchToProps = {
  validateAmount: actions.validateAmount,
  checkValidNoteToRecipient: actions.checkValidNoteToRecipient,
  selectPayees: actions.selectPayees,
  setControl: actions.setControl,
  removeControlPattern: actions.removeControlPattern,
  setSupplierPayoutType: actions.setSupplierPayoutType
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
